var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainLogoLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 362.742,
    height: 103.089,
    viewBox: "0 0 362.742 103.089",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M9.819-43.133a8.15,8.15,0,0,0-2.014,7.169h0c.563,3.324,5.421,5.745,9.92,7.018h0c1.5.429,3.114.739,4.83,1.07h0c1.021.195,2.069.4,3.132.63h0a31.643,31.643,0,0,1,10.025,3.729h0a10.523,10.523,0,0,0,4.794-3.168h0c1.133-1.392,2.4-2.923,1.857-5.674h0c-.618-3.163-5.712-5.864-10.21-7.136h0c-1.891-.508-3.33-.787-5-1.106h0c-.887-.172-1.84-.355-2.959-.591h0c-5.04-1.151-8.477-2.5-11.122-4.468h0a9.69,9.69,0,0,0-3.257,2.527",
    transform: "translate(-7.654 45.66)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-bl",
    x1: 0.036,
    y1: 0.595,
    x2: 0.132,
    y2: 0.595,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe73e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ffe03b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffd939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffd437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ffcd35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffc633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ffbf32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ffb930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ffb32f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ffad2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa72f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M210.826-71.132a1.018,1.018,0,0,0-.868.5h0c-2.673,4.411-22.238,36.7-28.038,46.035h0c.848,2.9,3.354,6.594,8.7,5.584h0c2.821-.534,3.981-1.853,5.665-4.467h0C199.139-27.908,217.291-58,224.255-69.5h0a1.058,1.058,0,0,0-.847-1.63H210.826Z",
    transform: "translate(-181.92 71.132)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-bl-2",
    x1: 0.421,
    y1: 0.918,
    x2: 0.735,
    y2: 0.918,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa72f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ffad2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffb32f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffb930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ffbf32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffc633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ffcd35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ffd437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ffd939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ffe03b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe73e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M182.967-38.27c-2.551.46-4.42,2.1-6.232,4.918h0c-2.413,3.743-11.038,17.935-13.977,22.777h0a1.056,1.056,0,0,0,.848,1.628h12.578a1.02,1.02,0,0,0,.866-.5h0c1.695-2.773,10.02-16.388,13.994-22.717h0c-.749-2.682-2.952-6.22-6.844-6.22h0a6.925,6.925,0,0,0-1.233.112",
    transform: "translate(-162.596 38.382)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-bl-3",
    x1: 0.22,
    y1: 0.808,
    x2: 0.397,
    y2: 0.808,
    xlinkHref: "#linear-gradient-bl"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M0,27.966H362.742V-75.123H0Z",
    transform: "translate(0 75.123)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1633",
    "data-name": "Group 1633",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    "data-name": "Group 350",
    transform: "translate(13.184 50.752)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_349",
    "data-name": "Group 349",
    transform: "translate(-13.184 -88.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M-7.654-57.522H356.721V109.141H-7.654Z",
    transform: "translate(7.654 57.522)",
    fill: "url(#linear-gradient-bl)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352",
    transform: "translate(313.366 6.875)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351",
    transform: "translate(-313.365 122.528) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M166.663,0V364.375H0V0Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-bl-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354",
    transform: "translate(280.079 63.288)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353",
    transform: "translate(-280.078 66.115) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M166.663,0V364.375H0V0Z",
    fill: "url(#linear-gradient-bl-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363",
    transform: "translate(0 0.001)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355",
    transform: "translate(56.203 29.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M16.433,9C15.4,15.622,13,17.219,5.345,17.219H-2.873L-.239.384h8.3C15.636.384,17.47,2.46,16.433,9m15-.479c2.553-15.716-2.553-20.982-19.785-20.982-7.577,0-15.555.319-23.535.956-.956.081-1.275.322-1.354,1.118L-22.658,49.21c-.238,1.037,0,1.276.959,1.276H-9.336c.959,0,1.2-.239,1.438-1.276l3.269-20.982H5.185c17.312,0,23.773-3.829,26.246-19.7",
    transform: "translate(22.744 12.459)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356",
    transform: "translate(102.203 29.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M11.161,14.055,19.619-5.889c.4-1.039.637-1.278,1.514-1.278,1.039,0,1.039.239,1.2,1.278l2.313,19.944ZM23.128-19.452c-10.211,0-12.046.718-15.956,9.653l-22.5,52.016c-.319.878,0,1.276.8,1.276H-2.321c.718,0,.878-.4,1.276-1.276L5.9,26.1H25.92l1.836,16.114c.079.878.158,1.276.877,1.276H40.839a1.138,1.138,0,0,0,1.276-1.276L36.131-9.8c-1.035-8.856-2.632-9.653-13-9.653",
    transform: "translate(15.447 19.452)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357",
    transform: "translate(164.988 29.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M16.434,9C15.4,15.622,13,17.219,5.344,17.219H-2.872L-.238.384h8.3C15.637.384,17.471,2.46,16.434,9M11.647-12.459c-7.577,0-15.556.319-23.535.956-.958.081-1.276.322-1.354,1.118L-22.659,49.21c-.238,1.037,0,1.276.959,1.276H-9.335c.958,0,1.2-.239,1.438-1.276l3.269-20.982h2.861l-.036,0,.055,0h.282c1.228.019,5.567.367,7.217,4.293,1.607,3.824,5.889,14.345,7.074,17.353a1.086,1.086,0,0,0,1.032.613H27.307c.7,0,1.18-.544.963-1.1C26.8,45.666,22.99,36.137,21.386,32.52c-1.9-4.289-7.509-5.133-7.509-5.133a19.71,19.71,0,0,0,8.041-2.7c5.622-3.623,8.546-8.1,9.514-16.166,1.895-15.809-2.553-20.982-19.785-20.982",
    transform: "translate(22.745 12.459)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358",
    transform: "translate(223.231 29.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M24.593.074,9.6-.1a2.12,2.12,0,0,0-1.5.851C4.713,4.967-7.3,19.723-11.724,25.087a20.6,20.6,0,0,1-2.06,2.167l.022-.152L-9.772,1.652c.079-.8-.239-1.275-1.039-1.275H-23.174a1.276,1.276,0,0,0-1.357,1.275l-9.493,59.915c-.081.877.238,1.275,1.037,1.275h12.364a1.233,1.233,0,0,0,1.357-1.275l4.553-28.246A12.539,12.539,0,0,1-11.863,37.1C-9.078,42.579-1.559,57.653.551,61.963a1.466,1.466,0,0,0,1.221.878H16.586c.7,0,1.013-.78.627-1.568C14.6,55.936,7.855,42.283,5.138,37.1a14.711,14.711,0,0,0-6.466-6.365,22.194,22.194,0,0,0,6.807-5.447C9.744,20.217,20.56,6.852,24.768,1.626c.62-.77.532-1.543-.176-1.552",
    transform: "translate(34.036 0.102)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359",
    transform: "translate(288.673 29.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M9.415,11.259a9.287,9.287,0,0,1-.381-.918v0c-.071-.186-.157-.351-.219-.553-.04-.127-.088-.295-.131-.439C7.389,5,3.095-11.1,2.114-14.79a1,1,0,0,0-.961-.758l-13.146-.034a1.076,1.076,0,0,0-1,1.369C-11.775-9.584-7.825,5.376-6.655,9.216c1.442,4.739,6.392,4.818,6.6,4.821H11.768a7.9,7.9,0,0,1-2.353-2.778",
    transform: "translate(13.03 15.582)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360",
    transform: "translate(13.178 30.525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M16.849.387A130.279,130.279,0,0,0,2.977-.535c-7.2,0-12.935,1.092-18.51,3.988q-.5.261-.954.546a13.04,13.04,0,0,0-5.831,8.85l-.351,2.458-.57,3.969-.079.553a14.133,14.133,0,0,1,6.537-4.02l.164-.059c9.657-3.092,16.147-2.828,31.512-1.108a1.3,1.3,0,0,0,1.43-1.094L18,1.852A1.3,1.3,0,0,0,16.849.387",
    transform: "translate(23.319 0.535)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361",
    transform: "translate(6.879 72.11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M14.608,1.684l-.2.071C4.759,4.845-1.735,4.582-17.106,2.861a1.3,1.3,0,0,0-1.43,1.092c-.386,2.668-1.28,8.968-1.669,11.706a1.3,1.3,0,0,0,1.149,1.459C-4.533,18.7,4.595,18.586,13.328,14.052c.332-.174.651-.358.956-.548a13.042,13.042,0,0,0,5.829-8.849l.293-2.046.415-2.889.295-2.052a14.124,14.124,0,0,1-6.508,4.015",
    transform: "translate(20.218 2.331)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362",
    transform: "translate(308.35 63.105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M10.386,11.85C9.168,7.221,5.218-7.741,4.049-11.579c-1.44-4.739-6.392-4.82-6.6-4.821h-11.82a7.868,7.868,0,0,1,2.353,2.778,8.734,8.734,0,0,1,.381.918c.071.188.158.353.219.553.04.129.088.3.131.441C-10-7.365-5.7,8.735-4.719,12.425a.994.994,0,0,0,.961.76l13.146.033a1.075,1.075,0,0,0,1-1.368",
    transform: "translate(14.374 16.4)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogoLarge);
export default __webpack_public_path__ + "static/media/MainLogoLarge.f74eeda0d4d6317f25766a286648763e.svg";
export { ForwardRef as ReactComponent };